import React from 'react'

const TechStack = () => {
  return (
    <>
    <details>
      <summary>Tech Stacks</summary>
      <ul>
        <li>Backend (Node.js)</li>
        <ul>
          <li>Express.js</li>
          <li>Sequelize</li>
          <li>Argon2</li>
          <li>Cors</li>
          <li>mysql2</li>
          <li>connect-session-sequelize</li>
          <li>Express session</li>
        </ul>
        <li>Frontend (React.js)</li>
        <ul>
          <li>Stuff CSS</li>
          <li>Axios</li>
          <li>react-redux</li>
        </ul>
        <li>Deploy on</li>
        <ul>
          <li>Cyclic.sh</li>
          <li>Netlify</li>
          <li>Cloud Clever</li>
        </ul>
      </ul>
    </details>
    </>
  )
}

export default TechStack